import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { InvoiceRequest } from './invoice-models';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/invoicerequest`;
  }

  getRequestList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<InvoiceRequest>> {
    return this.httpClient.get<AutoTablePageableResponse<InvoiceRequest>>(`${this._baseURL}s`, {
      params: params
    });
  }
}
